import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchInventoryCategories,
  fetchAllInventorySubcategories,
} from "store/slices/commonSlice";
import FormField from "components/common/FormField";

const CategorySubcategorySelect = ({
  category,
  subCategory,
  onCategoryChange,
  onSubCategoryChange,
  showAllOption = true,
}) => {
  const dispatch = useDispatch();

  const categories = useSelector(
    (state) => state.common?.inventoryCategories.items || []
  );

  const subcategories = useSelector(
    (state) => state.common?.allInventorySubcategories.items || []
  );

  // Fetch categories once
  useEffect(() => {
    dispatch(fetchInventoryCategories());
  }, [dispatch]);

  // Fetch subcategories based on category
  useEffect(() => {
    dispatch(
      fetchAllInventorySubcategories(
        category && category !== "all" ? category : null
      )
    );
  }, [category, dispatch]);

  return (
    <>
      {/* CATEGORY */}
      <FormField
        label="Category"
        name="category"
        type="select"
        value={category}
        onChange={(e) => onCategoryChange(e.target.value)}
        options={[
          ...(showAllOption ? [{ value: "all", label: "All" }] : []),
          ...categories.map((cat) => ({
            value: String(cat.id),
            label: cat.name,
          })),
        ]}
      />

      {/* SUB CATEGORY */}
      <FormField
        label="Sub Category"
        name="sub_category"
        type="select"
        value={subCategory}
        onChange={(e) => onSubCategoryChange(e.target.value)}
        options={[
        //   ...(showAllOption ? [{ value: "all", label: "All" }] : []),
          ...subcategories.map((sub) => ({
            value: String(sub.id),
            label: sub.name,
          })),
        ]}
      />
    </>
  );
};

export default CategorySubcategorySelect;
